import { Component, OnInit } from '@angular/core';
import { E5coreUiGenerateDocumentBaseComponent } from './e5core-ui-generate-document-base';

@Component({
  selector: 'e5core-ui-generate-document-bootstrap',
  templateUrl: './e5core-ui-generate-document-bootstrap.component.html',
  styleUrls: ['./e5core-ui-generate-document-bootstrap.component.css']
})
export class E5coreUiGenerateDocumentBootstrapComponent extends E5coreUiGenerateDocumentBaseComponent implements OnInit{
}